import { render, staticRenderFns } from "./RecommendLogin.vue?vue&type=template&id=5af83f12&scoped=true"
import script from "./RecommendLogin.vue?vue&type=script&lang=js"
export * from "./RecommendLogin.vue?vue&type=script&lang=js"
import style0 from "./RecommendLogin.vue?vue&type=style&index=0&id=5af83f12&prod&lang=less&scoped=true"
import style1 from "./RecommendLogin.vue?vue&type=style&index=1&id=5af83f12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af83f12",
  null
  
)

export default component.exports